import React, { useMemo } from 'react';
import { useLandingLanguage } from '../../context/LandingLanguageContext';
import { Gallery4 } from '@/components/ui/gallery4';

const publicImg = (file) => `${process.env.PUBLIC_URL || ''}/${file}`;

/** `public/assets/images/landing/gallery/` — service carousel art. */
const GALLERY_IMAGES = {
  qr: publicImg('assets/images/landing/gallery/qr-payments.jpg'),
  taxi: publicImg('assets/images/landing/gallery/taxi.jpg'),
  food: publicImg('assets/images/landing/gallery/delivery.jpeg'),
  esim: publicImg('assets/images/landing/gallery/esim.jpg'),
};

const SERVICE_KEYS = ['qr', 'taxi', 'food', 'esim'];

const SuperAppServices = () => {
  const { t } = useLandingLanguage();

  const galleryItems = useMemo(
    () =>
      SERVICE_KEYS.map((key) => ({
        id: key,
        title: t(`services.${key}.name`),
        description: t(`services.${key}.desc`),
        href: '/#waitlist',
        image: GALLERY_IMAGES[key],
      })),
    [t],
  );

  const title = (
    <>
      <span className="text-[#F5F1EA]">{t('services.h1')}</span>{' '}
      <span
        className="bg-[length:200%_auto] bg-gradient-to-br from-[#D4AF37] via-[#F0D070] to-[#D4AF37] bg-clip-text text-transparent"
        style={{ WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
      >
        {t('services.h2')}
      </span>
    </>
  );

  return (
    <section
      id="services"
      style={{
        position: 'relative',
        background: '#0F0F0F',
        padding: 'clamp(40px, 6vh, 72px) clamp(16px, 4vw, 36px) clamp(48px, 7vh, 88px)',
      }}
    >
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          zIndex: 0,
          background: 'radial-gradient(ellipse 85% 55% at 50% 0%, rgba(212,175,55,0.09) 0%, transparent 58%)',
        }}
      />

      <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <Gallery4
          className="py-0 pt-1"
          title={title}
          description={t('services.sub')}
          items={galleryItems}
          readMoreLabel={t('services.galleryReadMore')}
        />
      </div>
    </section>
  );
};

export default SuperAppServices;
